"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _awsAmplify = require("aws-amplify");
var _auth = require("aws-amplify/auth");
var _config = _interopRequireDefault(require("@xto10x/core/lib/config"));
var _utils = require("aws-amplify/utils");
var _cognito = require("aws-amplify/auth/cognito");
_awsAmplify.Amplify.configure({
  Auth: {
    Cognito: {
      // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
      identityPoolId: _config["default"].identityPoolId,
      // REQUIRED - Amazon Cognito Region
      region: _config["default"].region,
      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: _config["default"].userPoolId,
      // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
      userPoolClientId: _config["default"].userPoolWebClientId,
      loginWith: {
        oauth: {
          domain: _config["default"].authDomain,
          scopes: ['email', 'openid'],
          redirectSignIn: ["".concat(_config["default"].loginUrl, "/oauthcallback")],
          redirectSignOut: ["".concat(_config["default"].loginUrl)],
          responseType: 'code'
        }
      }
    }
  },
  Storage: {
    AWSS3: {
      bucket: _config["default"].s3Bucket,
      region: _config["default"].region
    }
  }
});
_cognito.cognitoUserPoolsTokenProvider.setKeyValueStorage(new _utils.CookieStorage({
  domain: _config["default"].cookieDomain
}));
var auth = {
  fetchAuthSession: function fetchAuthSession() {
    return (0, _auth.fetchAuthSession)();
  },
  signOut: function signOut() {
    return (0, _auth.signOut)();
  }
};
var _default = exports["default"] = auth;